var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DA576952-DF5F-439B-A43A-33043362ABA8@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PA/Topic-Page_L6-_Selected",
    transform: "translate(-182.000000, -239.000000)",
    fill: "#B7B7B7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pills-Copy-8",
    transform: "translate(58.000000, 230.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_delete_1832000_000000-copy",
    transform: "translate(124.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.92543683,2.92543683 C-0.975145609,6.82601926 -0.975145609,13.1739807 2.92543683,17.0745632 C6.82601926,20.9751456 13.1739807,20.9751456 17.0745632,17.0745632 C20.9751456,13.1739807 20.9751456,6.82601926 17.0745632,2.92543683 C13.1739807,-0.975145609 6.82694193,-0.975145609 2.92543683,2.92543683 Z M14.2417392,6.9016781 L11.3053457,9.83737962 L14.2410472,12.7730811 C14.646514,13.1785479 14.646514,13.8354189 14.2410472,14.2408858 C13.8355804,14.6463526 13.1787094,14.6463526 12.7732426,14.2408858 L9.83754109,11.3051842 L6.90183957,14.2415778 C6.49637276,14.6470446 5.83950176,14.6470446 5.43403495,14.2415778 C5.02856813,13.836111 5.02856813,13.17924 5.43403495,12.7737731 L8.36973646,9.83807162 L5.43334294,6.9016781 C5.02787613,6.49621129 5.02787613,5.83934029 5.43334294,5.43387348 C5.83880976,5.02840667 6.49568076,5.02840667 6.90114757,5.43387348 L9.83684909,8.369575 L12.7725506,5.43387348 C13.1780174,5.02840667 13.8348884,5.02840667 14.2403552,5.43387348 C14.6467216,5.83844069 14.6467216,6.49621129 14.2421574,6.9016781 L14.2417392,6.9016781 Z",
    id: "Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.8862f83a45cff60f1484f417b4d36c64.svg";
export { ForwardRef as ReactComponent };